import { render, staticRenderFns } from "./cfdeLanding.vue?vue&type=template&id=058a8073&scoped=true"
import script from "./cfdeLanding.vue?vue&type=script&lang=js"
export * from "./cfdeLanding.vue?vue&type=script&lang=js"
import style0 from "./cfdeLanding.vue?vue&type=style&index=0&id=058a8073&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a8073",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058a8073')) {
      api.createRecord('058a8073', component.options)
    } else {
      api.reload('058a8073', component.options)
    }
    module.hot.accept("./cfdeLanding.vue?vue&type=template&id=058a8073&scoped=true", function () {
      api.rerender('058a8073', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeLanding.vue"
export default component.exports